import * as React from 'react';
import styles from './index.less';
import Sider from './Sider';
import FSimpleBar from '@/components/FSimpleBar';
import { Outlet } from 'umi';

function Sidebar() {
  return (
    <div className={styles.leftRight}>
      <div className={styles.Slider}>
        <div>
          <Sider />
        </div>
      </div>
      <div className={styles.rightContent}>
        <FSimpleBar height={'calc(100vh - 70px)'}>
          <div className={styles.rightContent_inner}><Outlet /></div>
        </FSimpleBar>
      </div>
    </div>
  );
}

export default Sidebar;
